export default __webpack_public_path__ + "static/media/card_2@3x.f4cbfa5e.png";